
<script>

// CommitChart.js
import { Pie, mixins } from "vue-chartjs";

export default {
  name: 'PieChart',
  extends: Pie,
  mixins: [mixins.reactiveProp],
  props: ["options"],
  mounted () {
    // Overwriting base render method with actual data.
    this.renderChart(this.chartData, this.options)
  }
}

</script>

<style>



</style>


// WEBPACK FOOTER //
// src/components/PieChart.vue